import { render, staticRenderFns } from "./setting-add-accounting-year.vue?vue&type=template&id=4f5d916a"
import script from "./setting-add-accounting-year.vue?vue&type=script&lang=js"
export * from "./setting-add-accounting-year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports